module.exports = require("@mui/material/ListItemAvatar");